import type { AppDefinition } from '../../types/apps';

export const MemoryAppV2Definition: AppDefinition = {
  appId: 'memory-v2',
  name: 'Memory',
  version: '1.0.0',
  description: 'AI-readable memory and knowledge store',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Brain',
    phosphorWeight: 'duotone',
  },
  entityIcons: {
    Memory: {
      type: 'phosphor',
      phosphorIcon: 'Brain',
      phosphorWeight: 'duotone',
      color: '#8b5cf6',
    },
  },
  entityTypes: ['Memory'],
  component: 'memory-v2',
  requiresProps: false,
  requiresEntity: true,
  actions: {},
  // No standalone app icon (Dock/Store/CreateMenu Apps section) — "New Memory"
  // stays available as a quick-create entry everywhere.
  hidden: true,
};
